module.exports = __webpack_public_path__ + "static/media/mens.dfa7d473.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/mens.png
// module id = 382
// module chunks = 0